<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-body">
					<template v-if="item">
						<template v-if="users">
							<template v-if="users.length">
								<div class="row">
									<div class="col-md-12 center">
										<template v-for="value in users">
											<div class="radio radio-success">
												<input @change="changeAssigned" :id="'user-' + value.id" type="radio" :value="value.id" v-model="assigned_to">
												<label :for="'user-' + value.id">
													{{ value.email }}
												</label>
											</div>
										</template>
									</div>
								</div>
							</template>
						</template>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-change-budget-assigned'
				},

				users: null,
				item: null,
				loading:  null,
				assigned_to: null,
			}
		},
		methods: {
			open(item) {
				this.getUsers()
				this.item = null
				this.assigned_to = null
				if(item) {
					this.item = item
					this.assigned_to = item.assigned_to
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getUsers() {
				this.loading = true
				var data = {
					roles: [
						'admin', 'manager', 'external_manager', 'staff'
					]
				}
				this.$http.post('admin/roles/users', data)
				.then(response => {
					this.users = response.body
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.loading = false
				})
			},
			changeAssigned() {
				this.loading = true
				this.$http.get('admin/management/budgets/' + this.item.id + '/change/assigned/' + this.assigned_to)
				.then(response => {
					this.close()
					this.loading = false
					this.$emit('reload')
				}).catch(response => {
					console.log(response)
					this.close()
					this.loading = false
					if(response.status == 409) {
						swal({
							title: response.statusText,
							text: response.body,
							type: 'warning',
						})
					}
					this.$emit('reload')
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Assigned.vue